import { Image } from '@grubhubprod/gh-cookbook-react/dist';
import React from 'react';
import { getWindow } from 'src/utilities/window';
import { getConfig, IConfig } from 'src/utilities/config';

export interface CorporateLogoProps {
  logo?: keyof Pick<
    IConfig,
    'grubhubCorporateLogo' | 'grubhubCorporateLogoWhite'
  >;
}

export function CorporateLogo({
  logo = 'grubhubCorporateLogo',
}: CorporateLogoProps): JSX.Element {
  const window = getWindow();
  const config = getConfig();

  return (
    <a href={window.location.origin}>
      <Image
        width="152px"
        src={config[logo]}
        alt="Grubhub Corporate Accounts logo"
      />
    </a>
  );
}
